export default "__VITE_ASSET__wotOSvmQI$mysMr64mNvVw__"